import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  ToggleButtonGroup,
  ToggleButton,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import SelectInputs from 'src/components/inputs/SelectInputs';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { AiOutlineInfoCircle } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { QurealCollection, useQurealActions } from "qureal-editor";
import {
  setUpdatedDiscountMembershipData,
  setSelectedDiscountMembership,
  resetUpdatedDiscountMembershipData,
  removeMembershipFromState,
  updateMembershipInState,
  setLoading,
  updateDiscountType
} from '../../redux/slices/membershipSlice';
import { useDispatch, useSelector } from 'react-redux';
import { LinkedIn } from '@mui/icons-material';
import { changeDateFormate } from 'src/utils/dateutils';
import { getHighlightedText } from 'src/utils/textUtils';


export const TrimData = (data) => {
  if (data?.length < 25) return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

const taxStatusOptions = [
  { value: 'withTax', label: 'Inclusive (5% GST)' },
  { value: 'withoutTax', label: 'Exclusive (5% GST)' },
  // { value: 'noGst', label: 'No GST' },
]; 

const DiscountTypeFieldData = ({ data, state, branchData, search }) => {
  const dispatch = useDispatch();
  const {
    updatedDiscountMembershipData,
    selectedDiscountMembershipId,
    loading,
    discountTypes
  } = useSelector((state) => state.memberships);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [openEyeDialog, setOpenEyeDialog] = useState(false); // For the "eye" dialog
  const [selectedCardItem, setSelectedCardItem] = useState({});
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const { actionRef, download, share } = useQurealActions()
  const isGstRequired = !!(branchData?.gstNumber && branchData.gstNumber.trim().length > 0);

  const navigate = useNavigate();

  const { deleteMembership, updateMembership, setShowMessage, activeBranchId } = useMain();

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    dispatch(resetUpdatedDiscountMembershipData());
  };

  const taxableValue = useMemo(() => {
    const p = Number(updatedDiscountMembershipData?.membershipPrice) || 0;
    if (!isGstRequired) {
      return p.toFixed(2);
    }
    if (updatedDiscountMembershipData?.taxStatus === 'withTax') {
      return (p / 1.05).toFixed(2);
    }
    return p.toFixed(2);
  }, [updatedDiscountMembershipData?.membershipPrice, updatedDiscountMembershipData?.taxStatus, isGstRequired]);

  const handleDetails = (id) => {
    navigate(`/membershipdetail/${id}`, { state });
  };

  // const handleUpdate = (item) => {
  //   dispatch(setSelectedDiscountMembership(item));
  //   setOpenDialogue(true);
  // };
   const handleUpdate = (item) => {
    console.log(item,'item in dddddddddddddddd')
    // If the item has validTill, don't include duration in the update
    const dataToUpdate = {
      ...item,
      discount: {
        ...item.discount
      }
    };
    
    if (item.duration) {
      delete dataToUpdate.validTill;
    } else if (item.validTill) {
      delete dataToUpdate.duration;
    }
    
    dispatch(setSelectedDiscountMembership(dataToUpdate));
    setOpenDialogue(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setUpdatedDiscountMembershipData({ field: name, value }));
  };

  const handleDiscountChange = (e) => {
    const { name, value } = e.target;
    dispatch(setUpdatedDiscountMembershipData({
      field: `discount.${name}`,
      value
    }));
  };



  // const handleUpdateDiscountTypeMembership = async () => {
  //   try {
  //     dispatch(setLoading(true));
  //     const res = await updateMembership(
  //       selectedDiscountMembershipId,
  //       updatedDiscountMembershipData,
  //       `?branchId=${activeBranchId}`
  //     );

  //     if (res.statusCode === 200) {
  //       setShowMessage({
  //         message: res.message || 'Membership Details updated successfully',
  //         messageType: 'success',
  //       });

  //       // Update Redux state directly
  //       dispatch(updateMembershipInState({
  //         _id: selectedDiscountMembershipId,
  //         ...updatedDiscountMembershipData,
  //         membershipType: 'discountType'
  //       }));

  //       handleCloseDialogue();
  //     } else {
  //       setShowMessage({
  //         message: res.message || 'Membership Details not updated',
  //         messageType: 'error',
  //       });
  //     }
  //   } catch (error) {
  //     setShowMessage({
  //       message: error.message || 'Something went wrong',
  //       messageType: 'error'
  //     });
  //   } finally {
  //     dispatch(setLoading(false));
  //   }
  // };
  const handleUpdateDiscountTypeMembership = async () => {
    try {
      dispatch(setLoading(true));

      const isGstRequired = !!(branchData?.gstNumber && branchData.gstNumber.trim().length > 0);
      if (isGstRequired && (updatedDiscountMembershipData.taxStatus === 'noGst' || !updatedDiscountMembershipData.taxStatus)) {
        setShowMessage({
          message: 'Tax Status is required when GST number is present',
          messageType: 'error',
        });
        return;
      }
      
      // Prepare the payload based on whether duration or validTill exists
      let payload = { ...updatedDiscountMembershipData,
                      membershipPrice:Number(updatedDiscountMembershipData?.membershipPrice),
                      duration:Number(updatedDiscountMembershipData?.duration),
                      taxStatus: isGstRequired ? updatedDiscountMembershipData.taxStatus : 'noGst',
                      taxableValue: taxableValue
                    };
      
      if (payload.duration) {
        // If duration exists, remove validTill from payload
        delete payload.validTill;
      } else if (payload.validTill) {
        // If validTill exists, remove duration from payload
        delete payload.duration;
      }
      
      const res = await updateMembership(
        selectedDiscountMembershipId,
        payload,
        `?branchId=${activeBranchId}`
      );

      if (res.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Membership Details updated successfully',
          messageType: 'success',
        });

        // Update Redux state directly
        dispatch(updateMembershipInState({
          _id: selectedDiscountMembershipId,
          ...payload,
          membershipType: 'discountType'
        }));

        handleCloseDialogue();
      } else {
        setShowMessage({
          message: res.message || 'Membership Details not updated',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error'
      });
    } finally {
      dispatch(setLoading(false));
    }
  };


  const handleDeleteField = (id) => {
    setDeleteId(id); // Set the ID to be deleted
    setOpenDeleteDialog(true); // Open confirmation dialog
  }

  const handleEyeClick = (item) => {
    setSelectedCardItem(item);
    setOpenEyeDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenEyeDialog(false);
  };

  const confirmDelete = async () => {
    setDeleteLoading(true);
    try {
      const res = await deleteMembership(deleteId, `?branchId=${activeBranchId}`);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Membership deleted successfully',
          messageType: 'success',
        });

        // Remove from Redux state
        dispatch(removeMembershipFromState(deleteId));
      } else {
        setShowMessage({
          message: res.message || 'Membership not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setOpenDeleteDialog(false);
      setDeleteId(null);
      setDeleteLoading(false);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };

  const handleDiscountTypeChange = (event, newDiscountType, type) => {
    if (newDiscountType !== null) {
      dispatch(updateDiscountType({
        field: type,
        value: newDiscountType
      }));
    }
  };

   // Format the duration/validTill display
  const formatDurationDisplay = (item) => {
    if (item.duration) {
      return `${item.duration} Month${item.duration > 1 ? 's' : ''}`;
    } else if (item.validTill) {
      return changeDateFormate(item.validTill);
    }
    return 'N/A';
  };

  console.log(data, 'dataaaaaa')
  return (
    <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
      {/* <table className="table-container mt-3">
        <thead className="table-thead">
          <tr>
            {[
              'Membership Name',
              'Membership Price',
              'Validity',
              'Discount on Services',
              'Discount on Products',
              // 'Discount on Packages',
              'Min Billed Amount',
              'Rewards Points',
              'Actions',
              'Cards'
            ].map((h, index) => (
              <th key={index} style={{ width: '20%' }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table-tbody">
          {data.map((item) => (
            <tr key={item._id}>
              <td style={{ width: '100%' }}>{TrimData(item?.membershipName)}</td>
              <td style={{ width: '100%' }}>{item?.membershipPrice}</td>
              <td style={{ width: '100%' }}>{changeDateFormate(item?.duration ? item?.duration : item?.validTill)}</td>
              <td style={{ width: '100%' }}>
                {`${item?.discount?.discountOnService} ${item?.discount?.serviceDiscountType}`}
              </td>
              <td style={{ width: '100%' }}>
                {`${item?.discount?.discountOnProduct} ${item?.discount?.productDiscountType}`}
              </td>
              <td style={{ width: '100%' }}>{item?.discount?.minBillAmount}</td>
              <td style={{ width: '100%' }}>{item?.rewardPointsOnPurchase}</td>
              <td
                style={{
                  width: '100%',
                  marginLeft: '-3.2rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '3rem',
                }}
              >
                <IconButton
                  onClick={() => handleDetails(item._id)}
                  color="primary"
                  title="View Details"
                  style={{ marginRight: '-5px' }}
                >
                  <AiOutlineInfoCircle
                    style={{ color: '#696969', fontSize: '1.1rem', marginLeft: '1.5rem' }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => handleUpdate(item)}
                  color="secondary"
                  title="Update"
                  style={{ marginRight: '24px' }}
                >
                  <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                </IconButton>
                <IconButton
                  onClick={() => handleDeleteField(item._id)}
                  color="error"
                  title="Delete"
                  style={{ marginLeft: '-33px' }}
                >
                  <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem', marginTop: '1px' }} />
                </IconButton>
                <IconButton onClick={() => handleEyeClick(item)} color="primary" title="View">
                  <FaEye
                    color="black"
                    style={{ fontSize: '1.2rem', marginTop: '1px', marginLeft: '10px' }}
                  />
                </IconButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table> */}
      <table className="table-container mt-3" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead className="table-thead">
          <tr>
            <th style={{ width: '15%', textAlign: 'center', padding: '4px' }}>Membership Name</th>
            <th style={{ width: '10%', textAlign: 'center', padding: '4px' }}>Membership Price</th>
            <th style={{ width: '10%', textAlign: 'center', padding: '4px' }}>Duration</th>
            <th style={{ width: '12%', textAlign: 'center', padding: '4px' }}>Discount on Services</th>
            <th style={{ width: '12%', textAlign: 'center', padding: '4px' }}>Discount on Products</th>
            <th style={{ width: '10%', textAlign: 'center', padding: '4px' }}>Min Billed Amount</th>
            <th style={{ width: '10%', textAlign: 'center', padding: '4px' }}>Rewards Points</th>
            <th style={{ width: '16%', textAlign: 'center', padding: '4px' }}>Actions</th>
            <th style={{ width: '5%', textAlign: 'center', padding: '4px' }}>Cards</th>
          </tr>
        </thead>
        <tbody className="table-tbody">
          {data.map((item) => (
            <tr key={item._id} style={{ borderBottom: '1px solid #f0f0f0' }}>
              <td style={{ width: '15%', padding: '8px', textAlign: 'center' }}>
                {getHighlightedText(item?.membershipName, search)}
              </td>              
              <td style={{ width: '10%', padding: '8px',textAlign: 'center', }}>{item?.membershipPrice}</td>
              <td style={{ width: '10%', padding: '8px',textAlign: 'center', }}>{formatDurationDisplay(item)}</td>
              <td style={{ width: '12%', padding: '8px',textAlign: 'center', }}>
                {`${item?.discount?.discountOnService} ${item?.discount?.serviceDiscountType}`}
              </td>
              <td style={{ width: '12%', padding: '8px',textAlign: 'center', }}>
                {`${item?.discount?.discountOnProduct} ${item?.discount?.productDiscountType}`}
              </td>
              <td style={{ width: '10%', padding: '8px',textAlign: 'center', }}>{item?.discount?.minBillAmount}</td>
              <td style={{ width: '10%', padding: '8px',textAlign: 'center', }}>{item?.rewardPointsOnPurchase}</td>
              <td style={{ width: '16%', padding: '8px', textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                  <IconButton
                    onClick={() => handleDetails(item._id)}
                    color="primary"
                    title="View Details"
                    style={{ padding: '6px' }}
                  >
                    <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => handleUpdate(item)}
                    color="secondary"
                    title="Update"
                    style={{ padding: '6px' }}
                  >
                    <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDeleteField(item._id)}
                    color="error"
                    title="Delete"
                    style={{ padding: '6px' }}
                  >
                    <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
                  </IconButton>
                </div>
              </td>
              <td style={{ width: '5%', padding: '8px', textAlign: 'center' }}>
                <IconButton
                  onClick={() => handleEyeClick(item)}
                  color="primary"
                  title="View"
                  style={{ padding: '6px' }}
                >
                  <FaEye color="black" style={{ fontSize: '1.2rem' }} />
                </IconButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Dialog
        open={openEyeDialog}
        onClose={handleCloseDialog}
        maxWidth={false} // Disables default maxWidth handling
        PaperProps={{
          style: {
            width: '1100px', // Fixed width of the dialog
            height: '100vh', // Set height to 100vh
            margin: 'auto', // Centers the dialog horizontally
            display: 'flex', // Ensures the dialog content takes full height
            flexDirection: 'column', // Aligns content in a column
            borderRadius: '10px', // Border radius for smooth corners
            padding: '10px', // Padding around the dialog (optional)
          },
        }}
      >
        <DialogContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1, // Ensures content fills the available space
            padding: '0', // No padding inside content
            backgroundColor: 'white', // White background inside the content
            overflow: 'hidden', // Prevents vertical scrollbars
          }}
        >
          <QurealCollection
            collection_id="5cc9b8dc-f6d5-49fa-8fc8-658d9b3a4165"
            organization="your_salon_QBdXA"
            background="white" // White background for the collection
            style={{
              width: '100%', // Ensures the component fills the full width
              height: '100%', // Ensures the component fills the full height
              border: '1px solid black', // Border around the component
              borderRadius: '10px', // Rounded corners
              overflow: 'hidden', // Prevents scrollbars inside the component
            }}
            actionRef={actionRef}
            preview={true}
            prefill={{
              discount_offer: {
                offer_name: selectedCardItem?.membershipName,
                discount_amount: `${selectedCardItem?.discount?.serviceDiscountType === '%'
                    ? `${selectedCardItem?.discount?.discountOnService}%`
                    : `Rs${selectedCardItem?.discount?.discountOnService}`
                  }`,
                discount_on: `${selectedCardItem?.discount?.serviceDiscountType === '%'
                    ? `discount on all Services`
                    : `discount on all Services`
                  }${selectedCardItem?.discount?.discountOnProduct === 0 ? "." : `, and 
                  ${selectedCardItem?.discount?.productDiscountType === '%'
                      ? `${selectedCardItem?.discount?.discountOnProduct}% discount on all Products`
                      : `Rs${selectedCardItem?.discount?.discountOnProduct} discount on all Products`
                    }`}`,

                offer_price: `${selectedCardItem?.membershipPrice}`,
                validity: selectedCardItem?.duration
                  ? `valid for ${selectedCardItem?.duration} months`
                  : selectedCardItem?.validTill
                    ? `valid till ${changeDateFormate(selectedCardItem?.validTill)}`
                    : '',
                condition: `${selectedCardItem?.discount?.minBillAmount > 0 ? `only applicable on minimum bill amount Rs${selectedCardItem?.discount?.minBillAmount}` : "No minimum bill amount required."}`,
              },
              ai_model: {
                model: 'e9c8b5c4-4a2f-4c15-85a4-a57669a00999',
              },
              current_organization: {
                name: branchData?.branchName,
                primary_phone: branchData?.branchPhone,
                primary_email: branchData?.branchEmail,
                address: branchData?.address,
                website: branchData?.branchName,
                instagram_handle: '',
                linkedin_handle: '',
                logo: {
                  value: branchData?.logo?.url,
                },
                logo_dark: {
                  value: branchData?.logo?.url,
                },
                logo_square: {
                  value: branchData?.logo?.url,
                },
              },
            }}
          />
        </DialogContent>

        <DialogActions
          style={{
            display: 'flex',
            justifyContent: 'flex-end', // Align buttons to the right
            padding: '16px', // Padding for buttons
            backgroundColor: '#f5f5f5', // Optional: light grey background for the button section
          }}
        >
          <Button
            onClick={handleCloseDialog}
            color="primary"
            style={{
              marginRight: '10px', // Space between buttons
            }}
          >
            Close
          </Button>

          <Button
            variant="contained"
            color="primary"
            sx={{
              background: '#6174DD',
              marginRight: '10px', // Space between buttons
            }}
            onClick={share}
          >
            Share
          </Button>

          <Button
            variant="contained"
            color="primary"
            sx={{
              background: '#6174DD',
            }}
            onClick={download}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogContent>Are you sure you want to delete this Membership?</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* DiscountType membership details dialog */}
      <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
        <DialogTitle>DiscountType Membership Details</DialogTitle>
        <DialogContent>
          <DialogContentText>Here you can update membership details.</DialogContentText>

              <Box style={{ marginTop: '20px' }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <TextInputs
                      required={false}
                      title={'Membership Name'}
                      name={'membershipName'}
                      value={updatedDiscountMembershipData?.membershipName}
                      handleChange={handleChange}
                      type={'text'}
                    />
                  </Grid>
                  {!updatedDiscountMembershipData?.validTill && (
                    <Grid item xs={12} md={4}>
                      <TextInputs
                        required={false}
                        title={'Duration (in Months)'}
                        name={'duration'}
                        min={'0'}
                        value={updatedDiscountMembershipData?.duration}
                        handleChange={handleChange}
                        type={'number'}
                      />
                    </Grid>
                  )}
                  {!updatedDiscountMembershipData?.duration && (
                    <Grid item xs={12} md={4}>
                      <TextInputs
                        required={false}
                        title={'Valid Till'}
                        name={'validTill'}
                        value={updatedDiscountMembershipData?.validTill}
                        handleChange={handleChange}
                        type={'date'}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  )}

                  {/* Membership Price (+ Tax Status + Taxable Value) on the same row as Duration */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <label style={{
                        fontSize: "15px",
                        fontWeight: 600,
                        marginBottom: "8px",
                        display: "inline-block",
                        color: "#212529"
                      }}>Membership Price</label>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          height: "57px",
                          transition: 'border-color 0.2s ease-in-out',
                          '&:hover': {
                            borderColor: '#6174DD',
                          },
                        }}
                      >
                        <span style={{ padding: '0px 8px', fontSize: '16px', color: '#666' }}>₹</span>
                        <input
                          name="membershipPrice"
                          placeholder="0"
                          min="1"
                          value={updatedDiscountMembershipData?.membershipPrice}
                          onChange={handleChange}
                          type="number"
                          style={{
                            border: 'none',
                            outline: 'none',
                            flex: 1,
                            padding: '12px 0px',
                            fontSize: '16px',
                            background: 'transparent',
                            width: '100%'
                          }}
                        />
                        {isGstRequired && (
                          <Select
                            name="taxStatus"
                            value={updatedDiscountMembershipData?.taxStatus || 'noGst'}
                            onChange={handleChange}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            sx={{
                              background: '#F0F0F0',
                              border: 'none',
                              height: '100%',
                              borderTopLeftRadius: '0px',
                              borderBottomLeftRadius: '0px',
                              borderTopRightRadius: '3px',
                              borderBottomRightRadius: '3px',
                              '& .MuiSelect-select': {
                                padding: '8px 16px',
                                paddingRight: '24px !important',
                                height: '100% !important',
                                display: 'flex',
                                alignItems: 'center'
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                              },
                              '&:hover': {
                                background: '#e0e0e0',
                              },
                              '&.Mui-focused': {
                                background: '#e0e0e0',
                              },
                              borderLeft: '1px solid #ced4da'
                            }}
                          >
                            {taxStatusOptions.map(option => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      </Box>
                      {isGstRequired && (
                        <Box sx={{
                          p: '8px 12px',
                          backgroundColor: '#e9ecef',
                          border: '1px solid #ced4da',
                          borderTop: 'none',
                          borderRadius: '0 0 4px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}>
                          <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {taxableValue}</span>
                        </Box>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>

              {/* Row: Min Bill Amount, Reward Points, Discount Service+Type, Discount Product+Type — all in one line */}
              <Box style={{ marginTop: '20px' }}>
                <Grid container spacing={2} alignItems="flex-start">
                  <Grid item xs={6} md={2}>
                    <TextInputs
                      required={false}
                      title={'Min Bill Amount'}
                      name={'minBillAmount'}
                      value={updatedDiscountMembershipData?.discount?.minBillAmount}
                      handleChange={handleDiscountChange}
                      type={'number'}
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextInputs
                      required={false}
                      title={'Reward Points'}
                      name={'rewardPointsOnPurchase'}
                      value={updatedDiscountMembershipData?.rewardPointsOnPurchase}
                      handleChange={handleChange}
                      type={'number'}
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextInputs
                      required={false}
                      title={'Discount Service'}
                      name={'discountOnService'}
                      value={updatedDiscountMembershipData?.discount?.discountOnService}
                      handleChange={handleDiscountChange}
                      type={'number'}
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <div style={{ fontSize: '15px', fontWeight: 600, marginBottom: '8px', color: '#212529' }}>
                      Discount Type
                    </div>
                    <ToggleButtonGroup
                      value={updatedDiscountMembershipData?.discount?.serviceDiscountType}
                      exclusive
                      onChange={(event, newDiscountType) =>
                        handleDiscountTypeChange(event, newDiscountType, 'serviceDiscountType')
                      }
                      aria-label="service discount type"
                      fullWidth
                    >
                      {discountTypes.map((type) => (
                        <ToggleButton
                          key={type}
                          value={type}
                          sx={{
                            color: '#000',
                            backgroundColor: '#e0e0e0',
                            height: '57px',
                            '&.Mui-selected': {
                              backgroundColor: '#6174DD',
                              color: '#fff',
                              '&:hover': { backgroundColor: '#6174DD' },
                            },
                            '&:not(.Mui-selected)': {
                              '&:hover': { backgroundColor: '#d0d0d0' },
                            },
                          }}
                        >
                          {type}
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextInputs
                      required={false}
                      title={'Discount Product'}
                      name={'discountOnProduct'}
                      value={updatedDiscountMembershipData?.discount?.discountOnProduct}
                      handleChange={handleDiscountChange}
                      type={'number'}
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <div style={{ fontSize: '15px', fontWeight: 600, marginBottom: '8px', color: '#212529' }}>
                      Discount Type
                    </div>
                    <ToggleButtonGroup
                      value={updatedDiscountMembershipData?.discount?.productDiscountType}
                      exclusive
                      onChange={(event, newDiscountType) =>
                        handleDiscountTypeChange(event, newDiscountType, 'productDiscountType')
                      }
                      aria-label="product discount type"
                      fullWidth
                    >
                      {discountTypes.map((type) => (
                        <ToggleButton
                          key={type}
                          value={type}
                          sx={{
                            color: '#000',
                            backgroundColor: '#e0e0e0',
                            height: '57px',
                            '&.Mui-selected': {
                              backgroundColor: '#6174DD',
                              color: '#fff',
                              '&:hover': { backgroundColor: '#6174DD' },
                            },
                            '&:not(.Mui-selected)': {
                              '&:hover': { backgroundColor: '#d0d0d0' },
                            },
                          }}
                        >
                          {type}
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>
                  </Grid>
                </Grid>
              </Box>
          {/* <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Reward Points'}
                  name={'rewardPointsOnPurchase'}
                  value={updatedDiscountMembershipData?.rewardPointsOnPurchase}
                  handleChange={handleChange}
                  type={'number'}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Minimum Bill Amount'}
                  name={'minBillAmount'}
                  value={updatedDiscountMembershipData?.discount?.minBillAmount}
                  handleChange={handleDiscountChange}
                  type={'number'}
                />
              </Grid>
            </Grid>
          </Box> */}
        </DialogContent>
        <DialogActions>
          {loading ? (
            <ShowLoader />
          ) : (
            <>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleCloseDialogue}
                >
                  Cancel
                </Button>
              </div>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleUpdateDiscountTypeMembership}
                >
                  Update
                </Button>
              </div>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DiscountTypeFieldData;
